export const SIDEBAR = 'sidebar';
export const OVERLAY = 'overlay';
export const MODAL = 'modal';

// FIXME OVERLAY -> LEFT_SIDEBAR, MODAL -> OVERLAY
